import React from 'react'
import Bar from '../Chart/Bar';
import Pie from '../Chart/Pie';
import CardItem from './CardItem'

const Dashboard = () => {
    return (
        <div className='dashboard space-y-6'>
            <CardItem />
            <div className='flex gap-5 flex-col sm:justify-between'>
                <div className=' w-full sm:w-[60%]'>
                    <Bar />
                </div>
                <div className='w-full sm:w-[40%]'>
                    <Pie />
                </div>
            </div>
        </div>
    )
}

export default Dashboard;